import React from "react";
import MarketingPoint from "./components/marketingPoint";
import "./styles.css";
import amazingEffects from "./assets/amazing-features.png";
import lifetimeMembership from "./assets/lifetime-membership.png";
import noRestarts from "./assets/no-restarts.png";
import simpleSettings from "./assets/simple-settings.png";
import notACheat from "./assets/not-a-cheat.png";
import helpAndSupport from "./assets/help-and-support.png";
import A from "../../../../components/a";

const MarketingPoints = () => (
  <div className="marketing-points" id="features">
    <h2>Features</h2>
    <div>
      <MarketingPoint
        header="Gain the edge in PvP"
        image={amazingEffects}
        background="white"
        alignTo="left"
      >
        Ghast modifies settings focusing on differences between incoming and
        outgoing packets. The effects can be seen most in your knockback and hit
        registration, but you will notice the difference in anything network
        related too!
      </MarketingPoint>
      <MarketingPoint
        header="Access for life"
        image={lifetimeMembership}
        background="blue"
        alignTo="right"
      >
        When you buy Ghast, you have it for life! You will have full access to
        any updates, features, and improvements to the network settings. Anyone
        who buys Premium before Lightning release will be upgraded to Lightning
        even though its more!
      </MarketingPoint>
      <MarketingPoint
        header="No restarts needed"
        image={noRestarts}
        background="blue"
        alignTo="right"
      >
        Tired of having to restart every time you change your network settings?
        Ghast has you covered, our instant update protocol allows you to easily
        change settings without interupting your experience. With the time you
        save you could try our{" "}
        <span onClick={() => window.scrollTo(0, 0)}>
          <A className="link-color" href="/kohi-click-test">
            Kohi Click Test!
          </A>
        </span>
      </MarketingPoint>
      <MarketingPoint
        header="Not a cheat"
        image={notACheat}
        background="white"
        alignTo="left"
      >
        Ghast does not directly interact with Minecraft in any way, and does not
        violate rules on cheating since it only modifies your network
        configuration, it is also not a network limiter.
      </MarketingPoint>
      <MarketingPoint
        header="Simple settings"
        image={simpleSettings}
        background="white"
        alignTo="left"
      >
        Don't waste your time dealing with thousands of meaningless settings,
        Ghast simplifies everything by exposing a few simple settings and hiding
        any complexity away. Reducing your{" "}
        <A
          className="link-color"
          href="https://en.wikipedia.org/wiki/Lag"
          target="_blank"
        >
          Lag
        </A>{" "}
        too!
      </MarketingPoint>
      <MarketingPoint
        header="Help & Support"
        image={helpAndSupport}
        background="blue"
        alignTo="right"
      >
        Do you have questions, ideas, suggestions, or anything else? We are
        available to help you out. We make your experience as smooth as
        possible, we will solve your issue or give your money back!
      </MarketingPoint>
    </div>
  </div>
);

export default MarketingPoints;



/** WEBPACK FOOTER **
 ** ./src/views/pages/home/sections/marketingPoints/index.js
 **/